import React from 'react';
import { Card, Typography, Skeleton, Flex, Layout, Space } from 'antd';
import './RecoverAccount.css';

// Import assets
import loaderSrc from '../../assets/icons/loader.svg';

const { Title } = Typography;
const { Footer } = Layout;

export function RecoverAccountSkeleton(): React.ReactElement {
  return (
    <div className="sign-in-outer-container">
      <Flex className="sign-in-layout" justify="space-around" align="center">
        {/* Left side - Logo and Welcome Text */}
        <div className="sign-in-left-section">
          <div className="sign-in-brand-section">
            <div className="sign-in-logo-img" />
            <img src={loaderSrc} alt="Loader" className="sign-in-loader" />
            <Title level={1} className="sign-in-welcome-text">
              Welcome <br /> aboard.
            </Title>
          </div>
        </div>

        {/* Right side - Form Skeleton */}
        <div className="sign-in-right-section">
          <Card className="sign-in-card-container">
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
              <div className="sign-in-form-header">
                <Skeleton.Input active style={{ width: 250, height: 32 }} />
              </div>

              <div className="recover-account-form">
                <Skeleton.Input active style={{ width: '100%', height: 40 }} />
                <Skeleton.Button active style={{ width: '100%', height: 40 }} />
              </div>
            </Space>
          </Card>
        </div>
      </Flex>
      
      <Footer className="sign-in-footer">
        <span>Born from the spirit of discovery</span>
        <span>{getComputedStyle(document.documentElement).getPropertyValue('--ant-appName').trim()}.com</span>
      </Footer>
    </div>
  );
}